// src/components/content/MinisitePage.tsx
import React from 'react';
import Minisite from './Minisite/MinisiteContent';

const MinisitePage: React.FC = () => {
  return (
      <Minisite />
  );
};

export default MinisitePage;